/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './PopularityDataService.g';

// @ts-ignore
function vSIGetAPIResponseQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('VSIGetRestAPIResponse', 'VSIRestAPIHandler', DataServiceEntities.VSIRestAPIHandlerExtensionClass, key);
}

export function createVSIInitiateRestCallInput(ItemID: string, NoOfHours: string, Company: string): IDataServiceRequest {
    const query = vSIGetAPIResponseQuery();
    return query.createDataServiceRequestForOperation(
        'VSI_GetNoOfTransactions',
        true,
        DataServiceEntities.VSIRestAPIHandlerExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IVSIRestAPIHandler' },
        { ItemID: ItemID, NoOfHours: NoOfHours, Company: Company }
    );
}

export function vSIInitiateRestCallAsync(
    context: IContext,
    ItemID: string,
    NoOfHours: string,
    Company: string
): AsyncResult<DataServiceEntities.IVSIRestAPIHandler> {
    const request = createVSIInitiateRestCallInput(ItemID, NoOfHours, Company);
    return callActionOrExecute<DataServiceEntities.IVSIRestAPIHandler>(request, context.callerContext);
}
